import { jsonrepair } from "jsonrepair";
import { jwtDecode } from "jwt-decode";

class Utils {
  static tokenKey = "_t";
  /**
   * Common utils
   */
  static extractValFromToken(key) {
    return JSON.parse(window.atob(this.getLocalStorageItem(this.tokenKey)))[
      key
    ];
  }
  static extractValueFromToken(key) {
    const VALUE = sessionStorage.getItem(this.tokenKey);
    const tokenValue = VALUE ? jwtDecode(VALUE) : "";
    return tokenValue[key];
  }
  static parseJson(jsonString) {
    try {
      return JSON.parse(jsonString);
    } catch (error) {
      return {};
    }
  }

  static getDataFromToken() {
    const tokenData = this.getLocalStorageItem(this.tokenKey);
    return tokenData ? JSON.parse(window.atob(tokenData)) : null;
  }

  static setLocalStorageItem(key, value) {
    value = typeof value == "object" ? JSON.stringify(value) : value;
    return localStorage.setItem(key, value);
  }

  static getLocalStorageItem(key) {
    const VALUE = localStorage.getItem(key);
    return typeof VALUE == "object" ? JSON.parse(VALUE) : VALUE;
  }

  static removeLocalStorageItem(key) {
    return localStorage.removeItem(key);
  }

  static setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  };
  static getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };
  static formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };
  static getAllowExtensions = (allowedTypes = undefined) => {
    if (allowedTypes) {
      let EXTENSION = JSON.parse(allowedTypes) || [];
      EXTENSION = EXTENSION.map((exe) => exe.split(".").join(""));
      return EXTENSION;
    }
  };
  static getAllowFileSize = (maxSizeEachFileInMB = undefined) => {
    if (maxSizeEachFileInMB) {
      return maxSizeEachFileInMB * 1000001 || 10000000;
    }
  };
  static getAllowFileLimitMulti = (maxFiles = 0, filesLength = 0) => {
    if (maxFiles) {
      return maxFiles - filesLength;
    }
  };
  static getAllowFileLimit = (maxFiles = 0, filesLength = 0) => {
    if (maxFiles) {
      return maxFiles - filesLength;
    }
  };
  static repairJSON = (chunks) => {
    try {
      return jsonrepair(chunks);
    } catch (e) {
      return null; // return chunks;
    }
  };
  static parseJson = (string) => {
    try {
      return JSON.parse(string);
    } catch (e) {
      return null;
    }
  };
  static isJsonString = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };
  static removeQuotes = (str) => {
    if (str?.[0] === '"' && str?.[str.length - 1] === '"') {
      str = str?.slice(1, -1);
    }
    return str;
  };
  static formatedString = (str) => {
    if (!Utils.isJsonString(str)) {
      // str=JSON?.stringify(str, null, 4)
      if (typeof str == "string") {
        str = str?.replace(/\\n/g, "<br>")?.replaceAll('\\"', '"');
        str = str
          ?.replace(/\\r/, "")
          ?.replace(/\{/, "")
          ?.replace(/\}/, "")
          ?.replace(/"data":/, "");
        str = str
          ?.replace(/\\r/, "")
          ?.replace(/\{/, "")
          ?.replace(/\}/, "")
          ?.replace(/"answer":/, "")
          ?.replace(/"/, "");
        str = str?.trim();
      }
    } else {
      str = JSON?.stringify(JSON?.parse(str), null, 4)
        ?.replace(/\\n/g, "<br>")
        ?.replaceAll('\\"', "")
        ?.replace(/\{/, "")
        ?.replace(/"data":/g, "")
        // ?.replace(/\}/, "")
        ?.replace(/"answer":/g, "")
        ?.replace(/"/, "");
      if (str?.[str.length - 1] == "}") {
        str = str.slice(0, str.length - 1);
      }
      str = str?.trim();
    }
    return Utils.convertCodeBlocksToCodeElements(str);
  };
  static formattedStringUserMessage = (str) => {
    if (!Utils.isJsonString(str)) {
      if (typeof str == "string") {
        str = str?.replace(/\\n/g, "<br>")?.replaceAll('\\"', '"');
        str = str
          ?.replace(/\\r/g, "")
          ?.replace(/\{/g, "")
          ?.replace(/\}/g, "")
          ?.replace(/"data":/g, "");
        str = str
          ?.replace(/\\r/g, "")
          ?.replace(/\{/g, "")
          ?.replace(/\}/g, "")
          ?.replace(/"answer":/g, "");
        str = str?.trim();
      }
    } else {
      str = JSON?.stringify(JSON?.parse(str), null, 4)
        ?.replace(/\\n/g, "<br>")
        ?.replaceAll('\\"', '"')
        ?.replace(/\{/g, "")
        ?.replace(/"data":/g, "")
        ?.replace(/"answer":/g, "");
      if (str?.[str.length - 1] === "}") {
        str = str.slice(0, str.length - 1);
      }
      str = str?.trim();
    }

    if (str.startsWith('"') && !str.endsWith('"')) {
      str = `"${str}`;
    }

    return Utils.convertCodeBlocksToCodeElements(str);
  };

  static convertCodeBlocksToCodeElements = (responseText) => {
    // console.log(responseText);
    if (typeof responseText == "string") {
      // Regular expression pattern to identify code blocks
      const pattern = /```([\s\S]*?)```/g;

      // Replace code blocks with <code> elements
      const modifiedText = responseText?.replace(
        pattern,
        (match, codeBlock) => {
          // Wrap code block in <code> element
          return `<code>${codeBlock}</code>`;
        }
      );
      // console.log(modifiedText);
      return modifiedText;
    } else {
      return responseText;
    }
  };
  static formatDateTime = (dateString, showTime = true) => {
    const options = showTime
      ? {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }
      : { year: "numeric", month: "long", day: "numeric" };

    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  static capitalizeFirstLetter = (string) => {
    return string.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  static copyElement = (target) => {
    const range = document.createRange();

    range.setStart(target, 0);
    range.setEndAfter(target);
    window.getSelection()?.removeAllRanges();
    window.getSelection()?.addRange(range);

    document.execCommand("copy");

    window.getSelection()?.removeAllRanges();
  };
}
export default Utils;
